import { Badge } from "@/components/ui/Badge";
import {
  WYPIS_ORDER_STATUS_COLORS,
  WYPIS_ORDER_STATUS_LABELS,
  type WypisOrderStatus,
} from "../../types";

export function WypisStatusBadge({ status }: { status: WypisOrderStatus }) {
  return (
    <Badge color={WYPIS_ORDER_STATUS_COLORS[status] ?? "gray"}>
      {WYPIS_ORDER_STATUS_LABELS[status] ?? status}
    </Badge>
  );
}
